"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class residentDetailDto {
}
exports.residentDetailDto = residentDetailDto;
